// 336 hours is 14 days. We use these limits for performance reasons
// because QAPI needs to inject a time filter for granular time ranges.
// The cacheability of the time filter is poor, so it's untenable for long rolling-date queries.
export const LAST_HOURS_MAX: number = 336;
export const LAST_MINUTES_MAX: number = 336 * 60;
